import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getShows = createAsyncThunk("shows/get", async (payload) => {
  try {
    const response = await magnifiAPI.getShows(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteShow = createAsyncThunk("shows/delete", async (payload) => {
  try {
    const response = await magnifiAPI.deleteShow(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createShow = createAsyncThunk("shows/create", async (payload) => {
  try {
    const response = await magnifiAPI.createShow(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const updateShow = createAsyncThunk("shows/update", async (payload) => {
  try {
    const response = await magnifiAPI.updateShow(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
